import type { EventSummary, StageLook } from '@rabbitfuel/shared';
import { hasBackdrop } from './PlayerBackdrop.tsx';

/**
 * Das Standardbild: was im Stream laeuft, wenn abgeblendet ist.
 *
 * Ein abgeschalteter Videotrack schickt keine Bilder mehr, sondern Schwarz --
 * und Schwarz sieht bei YouTube genauso aus wie ein Abbruch. Deshalb kommt
 * hier eine eigene Ebene ins Bild, sobald die Regie oder die Quelle
 * abgeblendet hat: der Buehnen-Hintergrund des Events (der liegt ohnehin
 * schon darunter) mit einer ruhigen Karte darauf.
 *
 * Die Karte sagt bewusst wenig. Sie steht auch im Zuschauerbild und im
 * RTMP-Ausgang, und dort gehoert nur eine Information hin: es ist nicht
 * kaputt, es geht weiter. Warum abgeblendet wurde, interessiert allein die
 * Regie -- die sieht es in ihrem Monitor an der Beschriftung ihrer Knoepfe.
 *
 * Ohne gesetzten Buehnen-Hintergrund bringt die Pause ihren eigenen mit: eine
 * kleine Karte auf sonst voelligem Schwarz ist im Stream von einem Ausfall
 * kaum zu unterscheiden -- gesehen im RTMP-Mitschnitt eines Events, das seinen
 * Hintergrund auf „Schwarz" stehen hatte.
 */
export function StandbyCard({
  event,
  stage,
  note,
}: {
  event: EventSummary | null;
  stage: StageLook;
  note?: string;
}) {
  const accent = event?.accent ?? '#E11D2E';
  return (
    <div className="standby">
      {!hasBackdrop(stage, event) && (
        <div
          className="standby__ground"
          aria-hidden
          style={{
            background:
              `radial-gradient(120% 90% at 50% 12%, ${accent}59, transparent 68%), ` +
              `linear-gradient(168deg, #1b1e23 0%, ${accent}33 58%, #0b0c0e 100%)`,
          }}
        />
      )}
      <div className="standby__card">
        {event?.logoUrl && <img className="standby__logo" src={event.logoUrl} alt="" />}
        <b>{event?.title ?? 'Last Stream Standing'}</b>
        <span>Kurze Pause — es geht gleich weiter.</span>
        {note && <em>{note}</em>}
      </div>
    </div>
  );
}
